<template>
<div v-if="showJobBoard" class="job-board">

	<div class="vacancies-list">
		<ul>
			<li>
				<JobBoardCard :headline="jobs.headline" :titles="jobs.titles" :link="jobs.link" :readmore="jobs.readmore"/>
			</li>
		</ul>
	</div>

</div>
</template>

<script>
import JobBoardCard from '@/components/JobBoardCard'
export default {
	name: 'JobBoard',

	components: {
		JobBoardCard
	},
	data() {
		return {
			//profiles: this.$root.$data.profiles
			jobs: this.$root.$data.vacancies,
			showJobBoard: typeof this.$root.$data.vacancies === 'object'
		}
	}
}
</script>


<style scoped lang="scss">
@import "../scss/globals.scss";

.job-board {
	color: $color-white;
}

h2 {
	width: 100%;
	font-family: $font-expanded;
	font-size: $font-size-sm;

		margin-bottom: $margin1-4;
	@media screen and (min-width: 440px) {
		font-size: $font-size-m;
	}
	@media screen and (min-width: 769px) {
		font-size: $font-size-l;
	}
	@media screen and (min-width: 1025px) {
		font-size: 2.5vw;
	}
}

ul {
	padding: 0;
	margin: 0;
	max-width: 100vw;

	display: flex;
	flex-wrap: wrap;
	@media screen and (max-width: 768px) {
		margin: calc(#{$margin1-8} * -1);
	}

	li {
		list-style: none;

		width: 100%;
		max-width: inherit;
		margin: 0 auto;
		padding: $margin1-8;
		box-sizing: border-box;
		@media screen and (min-width: 769px) {
			padding: $margin1-2;
		}
	}
}

</style>
